'use client';

import React from 'react';
import { LucideIcon } from 'lucide-react';

interface Tab {
    id: string;
    label: string;
    icon: LucideIcon;
}

interface TabNavigationProps {
    tabs: Tab[];
    activeTab: string;
    onTabChange: (tabId: string) => void;
}

export function TabNavigation({ tabs, activeTab, onTabChange }: TabNavigationProps) {
    return (
        <div className="mx-auto flex items-center max-w-7xl px-4 py-4">
            <nav className="flex overflow-x-auto scrollbar-hide justify-start sm:justify-center gap-4 w-full" aria-label="Account tabs">
                {tabs.map((tab) => {
                    const isActive = activeTab === tab.id;
                    const Icon = tab.icon;

                    return (
                        <button
                            key={tab.id}
                            onClick={() => onTabChange(tab.id)}
                            className={`
                flex items-center gap-2 px-6 py-3 mt-2 text-sm font-medium whitespace-nowrap
                border-b-2 transition-colors
                ${isActive
                                    ? 'bg-hsecondary text-white rounded-xl hover:transition-all hover:duration-300 hover:ease-in-out hover:-translate-y-1'
                                    : 'bg-white text-hmuted rounded-xl hover:text-hsecondary hover:transition-all hover:duration-150 hover:ease-in-out hover:-translate-y-1'
                                }
              `}
                            aria-current={isActive ? 'page' : undefined}
                        >
                            <Icon className="h-5 w-5" />
                            {tab.label}
                        </button>
                    );
                })}
            </nav>
        </div>
    );
}
